var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 329,
    viewBox: "0 0 75 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-232.938 328.374C-214.023 304.986 -209.904 301.279 -190.495 286.463C-185.74 282.833 -176.496 277.121 -165.079 271.666C-161.662 270.031 -158.274 268.549 -154.933 267.19C-131.026 257.496 -104.243 256.128 -77.792 258.38C-10.3029 264.13 50.609 227.598 68.3663 172.287C86.1711 116.871 56.9015 55.3543 11.2412 25.3324C5.29997 21.4264 -22.7359 4.19639 -53.4956 1.64942C-150.615 -6.41915 -189.423 87.6571 -218.806 230.8C-219.376 233.585 -221.549 246.843 -221.938 249.656L-232.938 328.383L-232.938 328.374Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector13);
export default __webpack_public_path__ + "static/media/vector1-3.58185b7f3451a333d60a4a03373a1479.svg";
export { ForwardRef as ReactComponent };